export default function legParams(legs) {
  return legs.map((leg) => ({
    position: leg.position,
    board_station: leg.board_station.name,
    alight_station: leg.alight_station.name,
    reservations: reservationParams(leg.reservations),
  }))
}

const reservationParams = (reservations) => {
  return reservations.map((reservation) => ({
    desired_coach: reservation.desired_coach,
    desired_seat: reservation.desired_seat,
    alternative_coach: reservation.coach,
    alternative_seat: reservation.seat,
    desired_units: reservation.desired_units,
    alternative_units: reservation.units,
    status: reservation.status,
  }))
}
